import Vue from 'vue';

const showNotify = (title, text, group, type) => {
  Vue.notify({
    group,
    text,
    title,
    type
  });
};
export const notifySuccess = (title, text) => {
  showNotify(title, text, 'notif', 'success');
};
export const notifyError = (title, text) => {
  showNotify(title, text, 'notif', 'error');
};
export const notifyInfo = (title, text) => {
  showNotify(title, text, 'notif', 'info');
};
export const notifyWarning = (title, text) =>{
  showNotify(title, text, 'notif', 'warning');
};
